'use strict';

function Captcha(captchaId, onloadFunction, accessibilityFunction) {
    this.captchaId = captchaId;
    this.onloadFunction = onloadFunction;
    this.accessibilityFunction = accessibilityFunction;
    this.recaptchaWidgetID = null;
    this.renderred = false;
    this.completionFunction = null;
    this.form = null;
}

Captcha.prototype.renderCaptcha = function () {
    if (!this.renderred) {
        var $recaptcha = $('#' + this.captchaId);
        if ($recaptcha.length > 0) {
            if (!captchaInitialized) {
                captchaInitialized = true;

                var captchaLang = 'fr';
                if (lang != null) {
                    captchaLang = lang;
                }

                var captchaScript = document.createElement("script");
                captchaScript.async = true;
                captchaScript.type = 'text/javascript';
                captchaScript.src = 'https://www.google.com/recaptcha/api.js?onload=' + this.onloadFunction + '&render=explicit&hl=' + captchaLang;

                var node = document.getElementsByTagName("script")[0];
                node.parentNode.insertBefore(captchaScript, node);
            } else {
                var siteKey = $recaptcha.data('sitekey');
                if ($recaptcha.data('size') === 'invisible') {
                    var callback = $recaptcha.data('callback');
                    this.recaptchaWidgetID = grecaptcha.render(this.captchaId, {
                        'sitekey' : siteKey,
                        'callback' : callback
                    });
                } else {
                    this.recaptchaWidgetID = grecaptcha.render(this.captchaId, {
                        'sitekey' : siteKey
                    });
                }
                this.renderred = true;
                if (typeof this.accessibilityFunction === 'function') {
                    this.accessibilityFunction();
                }
            }
        }
    } else {
        this.resetCaptcha();
    }
};

Captcha.prototype.resetCaptcha = function () {
    if (this.recaptchaWidgetID != null) {
        grecaptcha.reset(this.recaptchaWidgetID);
        if (typeof this.accessibilityFunction === 'function') {
            this.accessibilityFunction();
        }
    }
};

Captcha.prototype.removeCaptcha = function () {
    if (this.recaptchaWidgetID != null) {
        grecaptcha.reset(this.recaptchaWidgetID);
        this.recaptchaWidgetID = null;
        this.renderred = false;
    }
};

Captcha.prototype.getResponse = function () {
    if (this.recaptchaWidgetID != null) {
        return grecaptcha.getResponse(this.recaptchaWidgetID);
    }
};
Captcha.prototype.executeCaptcha = function (completionFunction, $form, deferredObject) {
    if (this.recaptchaWidgetID != null) {
        if (completionFunction !== undefined && completionFunction !== null && completionFunction !== '') {
            this.completionFunction = completionFunction;
        }
        if (deferredObject !== undefined && deferredObject !== null && deferredObject !== '') {
            this.deferredObject = deferredObject;
        }
        if ($form !== undefined && $form !== null && $form !== '') {
            this.form = $form;
        }
        grecaptcha.execute(this.recaptchaWidgetID);
    }
};
Captcha.prototype.isEnabledAndInvisible = function () {
    return ($('#' + this.captchaId).length && $('#' + this.captchaId).attr('data-size') === 'invisible');
};
Captcha.prototype.completeLoginCallback = function (token) {
    window[this.completionFunction](token, this.deferredObject)
};
Captcha.prototype.completeCallbackWithForm = function (token) {
    window[this.completionFunction](token, this.form)
};

var onloadRenderCaptcha = function () {
    captcha.renderCaptcha();
};
var onloadRenderLoginCaptcha = function () {
    loginCaptcha.renderCaptcha();
};
var onloadRenderServiceCaptcha = function () {
    serviceCaptcha.renderCaptcha();
};
var onloadRenderOverlayCaptcha = function () {
    overlayCaptcha.renderCaptcha();
};

var accessibilityLoginCaptcha = function () {
    var $recaptcha = $('#' + this.captchaId);
    $recaptcha.find('iframe').attr('tabindex', '1');
};

//****************************************************************
// Internal callback for invisible reCAPTCHA v2
//****************************************************************
var onSubmitLoginCallback = function (token) {
    loginCaptcha.completeLoginCallback(token);
};
var onSubmitCallbackWithForm = function (token) {
    captcha.completeCallbackWithForm(token);
};

var captcha = new Captcha('recaptcha', 'onloadRenderCaptcha', null);
var loginCaptcha = new Captcha('loginRecaptcha', 'onloadRenderLoginCaptcha', accessibilityLoginCaptcha);
var serviceCaptcha = new Captcha('serviceRecaptcha', 'onloadRenderServiceCaptcha', null);
var overlayCaptcha = new Captcha('overlayRecaptcha', 'onloadRenderOverlayCaptcha', null);
var captchaInitialized = false;

$(document).ready(function () {
    if ($('#recaptcha').length > 0) {
        captcha.renderCaptcha();
    }
});